import React, { PureComponent } from 'react';
import {
  mouse as d3Mouse,
  select as d3Select,
  sum as d3Sum
} from 'd3';

import { loadData, loadSVG, incrementYear, decrementYear } from './VisState';
import { isOldIE } from '../../helper/utils';

import Sharer from '../../Component/Sharer';

const assetsContext = require.context('../../public/assets/images');
// const dataContext = require.context('../../public/data/import-export');

import './Vis.scss';

class ImportExportVis extends PureComponent {
  constructor() {
    super();

    this.exportSvg = false;
    this.importSvg = false;

    this.getTop15 = this.getTop15.bind(this);
    this.createTooltip = this.createTooltip.bind(this);
    this.incrementYear = this.incrementYear.bind(this);
    this.decrementYear = this.decrementYear.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(loadData());
    this.props.dispatch(loadSVG());
  }

  componentDidUpdate(){
    this.setTooltip();
  }

  setTooltip(){

    if (!(this.props.dataLoaded && this.props.svgDataLoaded)){
      return false;
    }

    let importTop15 = this.getTop15(this.props.importData);

    importTop15.sort(function(a, b){
      return b.value - a.value;
    });

    let exportTop15 = this.getTop15(this.props.exportData);

    exportTop15.sort(function(a, b){
      return b.value - a.value;
    });


    this.createTooltip(importTop15, '.import svg');
    this.createTooltip(exportTop15, '.export svg');

    d3Select('.vis-container')
      .selectAll('title')
      .text('');

  }


  createTooltip(data, container){
    const tooltip = d3Select('.vis-sankey--tooltip');
    const containerWidth = this.refs.sankeyContainer.clientWidth-75;

    d3Select(container)
      .selectAll('path')
      .on('mousemove', (d, i) => {
        tooltip.style('display','block')
          .style('top', `${d3Mouse(this.refs.sankeyContainer)[1]+20}px`)
          .style('left', () => {
            let mousePos = d3Mouse(this.refs.sankeyContainer)[0];
            mousePos = Math.min(Math.max(parseInt(mousePos, 10), 75), containerWidth);
            return `${mousePos - 75}px`;
          })
          .html(`
            <div class="sankey-tooltip--country">
              ${data[i].country === 'Vereinigte Staaten von Amerika' ? 'USA' : data[i].country}
            </div>
            <div class="sankey-tooltip--light">
              ${this.props.currentYear}
            </div>
            <div class="sankey-tooltip--value">
              ${Math.round(data[i].value).toLocaleString('de') === '0' ? 'Keine Daten vorhanden' : Math.round(data[i].value).toLocaleString('de')}t
            </div>
          `);
      })
      .on('mouseover', function(){
        tooltip.style('display','block')
      })
      .on('mouseout', function() {
        tooltip.style('display','none');
      });
  }


  getTop15(data){
    let allData = data.map(d => ({value: d[this.props.currentYear], value2015:d['2015'], country:d.Land}));

    allData.sort(function(a, b){
      return b.value2015 - a.value2015;
    });

    return allData.slice(0,15);
  }


  incrementYear() {
    this.props.dispatch(incrementYear());
  }

  decrementYear() {
    this.props.dispatch(decrementYear());
  }

  render() {
    const totalImport = d3Sum(this.props.importData, d => d[this.props.currentYear]);
    const totalExport = d3Sum(this.props.exportData, d => d[this.props.currentYear]);

    if (!(this.props.dataLoaded && this.props.svgDataLoaded)){
      return false;
    }

    return (
      <div className="import-export-vis">
        {
          <div>
            <div className="vis-stats">
              <div className="vis-stats-box">
                <div className="vis-stats-box--val">{(~~totalImport).toLocaleString('de-DE')}t</div>
                <div className="vis-stats-box--sub">{window.config.labels.import_ger}</div>
              </div>
              <div className="vis-stats-box center">
                <div onClick={this.decrementYear} className="vis-stats--arrow arrow_left"><div className="arrow-icon">
                  <img alt="arrow_back" className='arrow' src={assetsContext(`./arrow-back.svg`)}/>
                </div></div>
                <div className="year">
                  <div className="vis-stats-box--val">{this.props.currentYear}</div>
                  <div className="vis-stats-box--sub">{window.config.labels.import_choose_year}</div>
                </div>
                <div onClick={this.incrementYear} className="vis-stats--arrow arrow_right"><div className="arrow-icon">
                  <img alt="arrow_back" className='arrow' src={assetsContext(`./arrow-forward.svg`)}/>
                </div></div>
              </div>
              <div className="vis-stats-box">
                <div className="vis-stats-box--val">{(~~totalExport).toLocaleString('de-DE')}t</div>
                <div className="vis-stats-box--sub">{window.config.labels.export_ger}</div>
              </div>
            </div>

            <div className="vis-container" ref="sankeyContainer">
              { isOldIE ? null : <div className="vis-sankey--tooltip"></div> }
              { isOldIE ?
                <div className="svg-container-ie">
                  <div className="sankey-ie import" dangerouslySetInnerHTML={{ __html: this.props.import[`import${this.props.currentYear}`] }} />
                  <div className="sankey-ie export" dangerouslySetInnerHTML={{ __html: this.props.export[`export${this.props.currentYear}`] }} />
                </div> :
                <div className="svg-container">
                  <div className="sankey import" dangerouslySetInnerHTML={{ __html: this.props.import[`import${this.props.currentYear}`] }} />
                  <div className="sankey export" dangerouslySetInnerHTML={{ __html: this.props.export[`export${this.props.currentYear}`] }} />
                </div>
              }
            </div>

            <Sharer
              url={`${window.config.baseUrl}#import-export`}
              title={window.config.labels.import_vis_sharing_title}
              description={window.config.labels.import_vis_sharing_text}
              image={`${window.config.baseUrl}assets/images/b1_import_export_share.png`}
            />
          </div>
        }
      </div>
    )
  }
};


export default ImportExportVis;



// WEBPACK FOOTER //
// ./src/modules/ImportExportVis/Vis.js